export default "import { createVuetify } from 'vuetify'\n\nexport const vuetify = createVuetify({\n  theme: { defaultTheme: 'light' }\n})\n"